<div class="doksigen">

  <ion-card>
    <ion-card-header>
      <ion-card-title>Dokumentumgenerálás</ion-card-title>
      <ion-card-subtitle>
        Dolgozói dokumentumok (kinevezésmódosítás, szerződés, igazolás…) tömeges előállítása.
        A sablon szövegét a <b>kérvényszerkesztőben</b> állítod össze, az adatok az állományból
        és az itt megadott bérsorokból jönnek.
      </ion-card-subtitle>
    </ion-card-header>

    <ion-card-content>
      <ion-note color="warning" *ngIf="!jogosult" style="display:block;margin-bottom:10px">
        Ez a menüpont csak admin jogosultsággal használható.
      </ion-note>

      <!-- Sablon -->
      <div class="sor">
        <ion-item lines="full" class="novekvo">
          <ion-select label="Sablon" label-placement="stacked" interface="popover" [(ngModel)]="sablon"
                      (ionChange)="sablonValt()">
            <ion-select-option *ngFor="let s of sablonok" [value]="s.id">{{ s.name }}</ion-select-option>
          </ion-select>
        </ion-item>
        <ion-button size="small" fill="outline" (click)="szerkesztes()" [disabled]="!sablon">
          <ion-icon slot="start" name="create-outline"></ion-icon>Szöveg szerkesztése
        </ion-button>
        <ion-button size="small" fill="outline" (click)="ujSablonForm = !ujSablonForm">
          <ion-icon slot="start" name="add-outline"></ion-icon>Új sablon
        </ion-button>
        <ion-button size="small" fill="clear" color="danger" (click)="torolSablon()" [disabled]="!sablon">
          <ion-icon slot="start" name="trash-outline"></ion-icon>Törlés
        </ion-button>
      </div>

      <div class="uj-sablon" *ngIf="ujSablonForm">
        <ion-input label="Sablon neve" label-placement="stacked" [(ngModel)]="ujSablonNev"
                   placeholder="pl. Kinevezésmódosítás 2026"></ion-input>
        <ion-button size="small" (click)="ujSablon()">Létrehozás</ion-button>
        <ion-note color="medium">
          Létrehozás után a „Szöveg szerkesztése" gombbal nyílik a kérvényszerkesztő, ott írod meg
          a dokumentum szövegét a lenti mezőkkel.
        </ion-note>
      </div>

      <!-- Generálási menet: egy sablonból több, egymástól független köteg -->
      <div class="sor menet-sor">
        <ion-item lines="full" class="novekvo">
          <ion-select label="Generálási menet" label-placement="stacked" interface="popover"
                      [(ngModel)]="menet" (ionChange)="menetValt()"
                      placeholder="még nincs mentett menet">
            <ion-select-option *ngFor="let m of menetek" [value]="m.id">
              {{ m.nev }}{{ m.generalva ? ' • generálva' : '' }}
            </ion-select-option>
          </ion-select>
        </ion-item>
        <ion-button size="small" fill="outline" (click)="ujMenet(false)" [disabled]="!sablon">
          <ion-icon slot="start" name="add-outline"></ion-icon>Új menet
        </ion-button>
        <ion-button size="small" fill="outline" (click)="ujMenet(true)" [disabled]="!menet">
          <ion-icon slot="start" name="copy-outline"></ion-icon>Másolat
        </ion-button>
        <ion-button size="small" fill="clear" (click)="atnevezMenet()" [disabled]="!menet">
          Átnevezés
        </ion-button>
        <ion-button size="small" fill="clear" color="danger" (click)="torolMenet()" [disabled]="!menet">
          <ion-icon slot="start" name="trash-outline"></ion-icon>Menet törlése
        </ion-button>
      </div>
      <ion-note color="medium" class="menet-sugo">
        Egy sablonból többször is generálhatsz (pl. januári és szeptemberi kinevezésmódosítás):
        minden menetnek saját bérsorai, iktatószámai és megjegyzései vannak, egymást nem írják felül.
      </ion-note>

      <!-- Beszúrható mezők súgója -->
      <div class="mezo-sugo" *ngIf="mezoKatalogus">
        <details>
          <summary>Beszúrható mezők ({{ mezoKatalogus.csoportok.length }} csoport)</summary>
          <p class="sugo-szoveg">{{ mezoKatalogus.sugo }}</p>
          <div class="mezo-csoportok">
            <div *ngFor="let cs of mezoKatalogus.csoportok" class="mezo-csoport">
              <b>{{ cs.cim }}</b>
              <div class="mezo-lista">
                <code *ngFor="let m of cs.mezok" [title]="m.nev">{{ '{{' + m.kulcs + '}}' }}</code>
              </div>
            </div>
          </div>
        </details>
      </div>

      <!-- Közös mezők -->
      <div class="sor">
        <ion-input label="Tanév (bérsorok éve)" label-placement="stacked" type="number"
                   [(ngModel)]="ev" (ionBlur)="dolgozokBetolt()"></ion-input>
        <ion-input label="Hatálybalépés ({{ '{{hatalyos}}' }})" label-placement="stacked"
                   [(ngModel)]="mezok.hatalyos" (ngModelChange)="valtozott()" placeholder="pl. 2026. január 1."></ion-input>
        <ion-input label="Kelt (üres = mai nap)" label-placement="stacked" type="date"
                   [(ngModel)]="kelt" (ngModelChange)="valtozott()"></ion-input>
        <ion-input label="Közös megjegyzés ({{ '{{megjegyzes}}' }})" label-placement="stacked"
                   [(ngModel)]="mezok.megjegyzes" (ngModelChange)="valtozott()"
                   placeholder="mindenkinél ez jelenik meg, ha nincs saját"></ion-input>
      </div>
    </ion-card-content>
  </ion-card>

  <!-- Dolgozók + bérsorok -->
  <ion-card>
    <ion-card-header>
      <ion-card-title>Dolgozók és bérsorok</ion-card-title>
      <ion-card-subtitle>
        A bérsorok a <b>Bérek és pótlékok</b> menüből jönnek, a megadott napon érvényes
        állapot szerint; itt menetenként felülírhatók (a bér modult nem módosítják).
        A 0 összegű pótlék nem kerül a dokumentumba. A sort lenyitva dolgozónkénti
        megjegyzés is megadható, ami felülírja a fent közösen megadottat.
      </ion-card-subtitle>
    </ion-card-header>
    <ion-card-content>
      <div class="sor">
        <ion-searchbar placeholder="Keresés névre..." [(ngModel)]="kereses" [debounce]="150"></ion-searchbar>
        <ion-button size="small" fill="outline" (click)="mindKivalaszt(true)">Mind</ion-button>
        <ion-button size="small" fill="outline" (click)="mindKivalaszt(false)">Egyik sem</ion-button>
        <ion-badge color="primary">{{ kivalasztottak.length }} kijelölve</ion-badge>
        <ion-button size="small" fill="outline" (click)="berMenu()">
          <ion-icon slot="start" name="pricetags-outline"></ion-icon>
          Pótlék-gyűjtő és bérek ({{ jogcimek.length }} jogcím)
        </ion-button>
      </div>

      <div class="sor">
        <ion-input label="Bérsorok napja" label-placement="stacked" type="date"
                   [(ngModel)]="berdatum" (ngModelChange)="valtozott()"></ion-input>
        <ion-button size="small" fill="outline" (click)="berFrissit()">
          <ion-icon slot="start" name="refresh-outline"></ion-icon>Bérsorok frissítése
        </ion-button>
        <ion-note color="medium" class="ber-sugo">
          Ezen a napon érvényes bérrel dolgozik a menet. Ha időközben rögzítettek egy
          bérváltozást, a frissítéssel hozható be – a menetben kézzel átírt összegek ilyenkor
          felülíródnak.
        </ion-note>
      </div>

      <div *ngIf="betoltes" class="ion-text-center ion-padding">
        <ion-spinner name="crescent"></ion-spinner>
      </div>

      <div class="dolgozo-lista" *ngIf="!betoltes">
        <div class="dolgozo" *ngFor="let d of szurtDolgozok">
          <div class="dolgozo-fej">
            <ion-checkbox [checked]="d.kivalasztva"
                          (ionChange)="d.kivalasztva = $event.detail.checked; valtozott()"></ion-checkbox>
            <span class="nev">{{ d.viselt_vez }} {{ d.viselt_ker }}</span>
            <span class="muted">{{ d.munkakor || '—' }}</span>
            <span class="osszeg">{{ ft(osszesen(d)) }}</span>
            <ion-icon class="megj-jel" name="chatbox-ellipses-outline" *ngIf="vanMegjegyzes(d)"
                      title="Van saját megjegyzése"></ion-icon>
            <ion-input class="ikt" placeholder="Iktatószám" [(ngModel)]="d.iktatoszam"
                       (ngModelChange)="valtozott()" [disabled]="!d.kivalasztva"></ion-input>
            <ion-button size="small" fill="clear" (click)="d.nyitva = !d.nyitva">
              <ion-icon slot="icon-only" [name]="d.nyitva ? 'chevron-up-outline' : 'chevron-down-outline'"></ion-icon>
            </ion-button>
          </div>

          <div class="ber-szerkeszto" *ngIf="d.nyitva">
            <ion-input label="Alapbér" label-placement="stacked" type="number" [(ngModel)]="d.alapber"
                       (ngModelChange)="valtozott()"></ion-input>

            <!-- Gyűjtőbeli jogcímek: elég bepipálni -->
            <div class="gyujto-valaszto" *ngIf="d.sorok?.length">
              <div class="valaszto-sor" *ngFor="let s of d.sorok">
                <ion-checkbox [checked]="s.be" labelPlacement="end"
                              (ionChange)="jogcimValt(d, s, $event.detail.checked)">{{ s.jogcim }}</ion-checkbox>
                <ion-input *ngIf="s.be" label="Összeg" label-placement="stacked" type="number"
                           [(ngModel)]="s.osszeg" (ngModelChange)="valtozott()"></ion-input>
              </div>
            </div>
            <ion-note color="medium" *ngIf="!jogcimek.length" class="gyujto-ures">
              A pótlék-gyűjtő még üres – a jogcímeket a <b>Dolgozók → Bérek és pótlékok</b>
              menüben viheted fel, itt már csak pipálni kell őket.
            </ion-note>

            <!-- Csak ennél a dolgozónál előforduló, egyedi pótlék -->
            <div class="potlek-sor" *ngFor="let p of d.egyeb; let i = index">
              <ion-input label="Egyedi jogcím" label-placement="stacked" [(ngModel)]="p.jogcim"
                         (ngModelChange)="valtozott()" placeholder="pl. eseti megbízás"></ion-input>
              <ion-input label="Összeg" label-placement="stacked" type="number" [(ngModel)]="p.osszeg"
                         (ngModelChange)="valtozott()"></ion-input>
              <ion-button size="small" fill="clear" color="danger" (click)="torolPotlek(d, i)">
                <ion-icon slot="icon-only" name="close"></ion-icon>
              </ion-button>
            </div>
            <div class="megjegyzes-sor">
              <ion-textarea label="Megjegyzés – csak ennél a dolgozónál" label-placement="stacked"
                            [autoGrow]="true" rows="2" [(ngModel)]="d.megjegyzes" (ngModelChange)="valtozott()"
                            placeholder="A sablon {{ '{{megjegyzes}}' }} mezőjébe kerül; ha üres, a közösen megadott szöveg jelenik meg."></ion-textarea>
              <ion-note color="medium">
                Sablononként és tanévenként külön tárolódik, a következő generálásnál visszatöltjük.
              </ion-note>
            </div>
            <div class="ber-gombok">
              <ion-button size="small" fill="outline" (click)="ujPotlek(d)">
                <ion-icon slot="start" name="add-outline"></ion-icon>Pótlék hozzáadása
              </ion-button>
              <ion-button size="small" (click)="mentBer(d)">
                <ion-icon slot="start" name="save-outline"></ion-icon>Menet mentése
              </ion-button>
            </div>
          </div>
        </div>

        <ion-note color="medium" *ngIf="!szurtDolgozok.length" class="ion-padding" style="display:block">
          Nincs a keresésnek megfelelő dolgozó.
        </ion-note>
      </div>
    </ion-card-content>
  </ion-card>

  <!-- Kimenet -->
  <ion-card>
    <ion-card-header>
      <ion-card-title>Kimenet</ion-card-title>
    </ion-card-header>
    <ion-card-content>
      <div class="kimenet">
        <ion-item lines="none">
          <ion-checkbox slot="start" [checked]="kimenet.osszefuzott"
                        (ionChange)="kimenet.osszefuzott = $event.detail.checked; valtozott()"></ion-checkbox>
          <ion-label class="ion-text-wrap">
            Egy összefűzött PDF nyomtatáshoz
            <p>Minden dolgozó irata egy fájlban, duplex-párnázással (páratlan oldalszám után üres lap),
              hogy kétoldalas nyomtatásnál ne csússzon át a következő dolgozó irata.</p>
          </ion-label>
        </ion-item>
        <ion-item lines="none">
          <ion-checkbox slot="start" [checked]="kimenet.kulon"
                        (ionChange)="kimenet.kulon = $event.detail.checked; valtozott()"></ion-checkbox>
          <ion-label class="ion-text-wrap">
            Dolgozónként külön PDF a dokumentumtárba
            <p>Visszakereshetően eltárolva, a Generált dokumentumok listában megjelenik.</p>
          </ion-label>
        </ion-item>
        <ion-item lines="none">
          <ion-checkbox slot="start" [checked]="kimenet.alairt" [disabled]="!kimenet.kulon"
                        (ionChange)="kimenet.alairt = $event.detail.checked; valtozott()"></ion-checkbox>
          <ion-label class="ion-text-wrap">
            Digitálisan aláírva
            <p>A tárolt PDF-eket a tanúsítvány-kezelőben aktívra állított tanúsítvánnyal írja alá.</p>
          </ion-label>
        </ion-item>
        <ion-item lines="none">
          <ion-checkbox slot="start" [checked]="kimenet.docx"
                        (ionChange)="kimenet.docx = $event.detail.checked; valtozott()"></ion-checkbox>
          <ion-label class="ion-text-wrap">
            Szerkeszthető DOCX is (ZIP)
            <p>Ha utólag kézzel kell javítani egy iratot. A letöltés ilyenkor ZIP.</p>
          </ion-label>
        </ion-item>
        <ion-item lines="none">
          <ion-checkbox slot="start" [checked]="kimenet.oldalszam"
                        (ionChange)="kimenet.oldalszam = $event.detail.checked; valtozott()"></ion-checkbox>
          <ion-label class="ion-text-wrap">
            Oldalszámozás a lap alján
            <p>Dolgozónként újraindul (minden irat 1. oldallal kezdődik), az összefűzött
              PDF-ben is – így nyomtatás után is látszik, hány lapos egy irat.</p>
          </ion-label>
        </ion-item>
        <ion-item lines="none" *ngIf="kimenet.oldalszam">
          <ion-select label="Oldalszám formája" label-placement="stacked" interface="popover"
                      [(ngModel)]="kimenet.oldalszam_forma" (ionChange)="valtozott()">
            <ion-select-option value="per">1 / 3</ion-select-option>
            <ion-select-option value="szoveges">1. oldal / 3</ion-select-option>
            <ion-select-option value="sima">1</ion-select-option>
          </ion-select>
        </ion-item>
      </div>

      <div class="gombok">
        <ion-button fill="outline" color="success" (click)="mentes()" [disabled]="folyamatban || !sablon">
          <ion-icon slot="start" name="save-outline"></ion-icon>Mentés
        </ion-button>
        <ion-button fill="outline" (click)="elonezet()" [disabled]="folyamatban || !sablon">
          <ion-icon slot="start" name="eye-outline"></ion-icon>Előnézet
        </ion-button>
        <ion-button fill="outline" (click)="elonezetPdf()" [disabled]="folyamatban || !sablon">
          <ion-icon slot="start" name="download-outline"></ion-icon>Előnézet PDF-be
        </ion-button>
        <ion-button (click)="generalas()" [disabled]="folyamatban || !jogosult">
          <ion-icon slot="start" name="documents-outline"></ion-icon>
          Generálás ({{ kivalasztottak.length }} dolgozó)
        </ion-button>
      </div>
      <div class="mentes-allapot">
        <ion-note [color]="piszkos ? 'warning' : 'medium'">
          <ng-container *ngIf="piszkos">
            Mentetlen változás – a Mentés gombbal megőrizhető, generáláskor magától mentődik.
          </ng-container>
          <ng-container *ngIf="!piszkos && mentve">
            Utoljára mentve: {{ mentve | date: 'yyyy. MM. dd. HH:mm' }}
            <ng-container *ngIf="aktualisMenet"> – „{{ aktualisMenet.nev }}"</ng-container>
          </ng-container>
          <ng-container *ngIf="!piszkos && !mentve && !menet">
            Még nincs mentett menet: a Mentés gombbal hozhatsz létre egyet.
          </ng-container>
        </ion-note>
      </div>

      <div class="elonezet" *ngIf="elonezetHtml">
        <div class="elonezet-fej">
          <h3>Előnézet – {{ elonezetNev }}</h3>
          <ion-button size="small" fill="clear" (click)="elonezetPdf()" [disabled]="folyamatban">
            <ion-icon slot="start" name="download-outline"></ion-icon>PDF-be mentés
          </ion-button>
        </div>
        <div class="elonezet-lap" [innerHTML]="elonezetHtml"></div>
      </div>
    </ion-card-content>
  </ion-card>
</div>
